// Disable 'params re-assign', because we are processing the same value.
/* eslint-disable no-param-reassign */
/**
 * Add mask to the field, and filter all values except numbers.
 * @description
 *  | 0 | 000 | 0.000 | 00.000 | 0.000.000
 * @param {String | Number} value
 * @param {String} currencySeparator
 */
const maskSalary = (value, currencySeparator) => {
  // Convert Number to String
  if (typeof value === 'number') {
    value = value.toString();
  }
  if (typeof value !== 'string' || typeof currencySeparator !== 'string') {
    throw new TypeError('The value and separator should of string type.');
  }
  // Remove non numbers characters.
  value = value.replace(/\D/g, '');
  // Add dot after three digits: 1000 -> 1.000.
  value = value.replace(/(\d)(\d{3})$/, `$1${currencySeparator}$2`);
  // Add a dot when the value is 7 digits.
  // 1000.000 -> 1.000.000
  value = value.replace(/(?=(\d{3})+(\D))\B/g, `${currencySeparator}`);
  // Update value
  return value;
};

export default maskSalary;
